document.addEventListener("DOMContentLoaded", function () {
  const swiperContainer = document.querySelectorAll(
    ".animation--collection-items.swiper"
  );

  if (swiperContainer.length > 0) {
    swiperContainer.forEach((swiper) => {
      const swiperProductCollection = new Swiper(swiper, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        breakpoints: {
          749: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
        },
        navigation: {
          nextEl: swiper.closest('.collection__container').querySelector(".swiper-button-next"),
          prevEl: swiper.closest('.collection__container').querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: swiper.closest('.collection__container').querySelector(".swiper-pagination--slider"),
          clickable: true,
        },
        on: {
          init: function () {
            this.navigation.init();
            this.navigation.update();
          },
        },
      });

      swiperProductCollection.on("slideChange", function () {
        swiperProductCollection.pagination.render();
        swiperProductCollection.pagination.update();
      });
    });
  }
});